export enum PageEvent {
	enter = 'page-enter',
	enterComplete = 'page-enter-complete',
	leave = 'page-leave',
}
